import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { SendMessageComponent } from '../send-message/send-message.component';
import {NgbTabChangeEvent} from '@ng-bootstrap/ng-bootstrap';
import { MessagingService } from '../../services/messaging.service';
import { JobOffersService } from '../../services/job-offers.service';
import { MessageBoxDialog } from '../message-box/message-box.component';
import {Pagination} from "../../models/message";
import { ApplyStatusService } from "../../services/apply-status.service";
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import {Observable} from "rxjs";

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {
  selectedOption: string;
  loading: boolean;
  messagesDirect: any;
  messagesMassive: any;
  errorMessage:string;
  req: number;

  optionsModel: number[];
  myOptions: IMultiSelectOption[];

  jobId: string;
  jobs: Observable<any[]>;
  query: string;
  favorite: string;
  read: boolean;
  unread: boolean;
  rejected: boolean;
  selected: boolean;
  hired: boolean;
  offer_id: string;
  custom: any;

  paginationDirect: Pagination = {total: 0, pages: 0, pageCount: 0};
  maxMessagesDirect = 10;
  currentPageDirect = 1;

  paginationMassive: Pagination = {total: 0, pages: 0, pageCount: 0};
  maxMessagesMassive = 10;
  currentPageMassive = 1;

  mySettings: IMultiSelectSettings = {
      enableSearch: false,
      checkedStyle: 'glyphicon',
      buttonClasses: 'btn btn-default btn-block',
      dynamicTitleMaxItems: 10,
      displayAllSelectedText: true
  };

myTexts: IMultiSelectTexts = {
      checkAll: 'Seleccionar Todos',
      uncheckAll: 'Remover Todos',
      checked: 'Estado Seleccionado',
      checkedPlural: 'Estados Seleccionados',
      searchPlaceholder: 'Buscar',
      defaultTitle: 'Seleccionar Estado',
      allSelected: 'Seleccionar Todos',
  };

  constructor(public dialog: MdDialog,
    public messageService:MessagingService,
    private jobService: JobOffersService,
    private applyStatusService: ApplyStatusService,

  ) { }

  ngOnInit() {
    this.req = 1;
    this.getOffers();
    this.searchMessages(1);

    this.applyStatusService.getApplyStatusList().subscribe(
      data => {
        let dat= [];
        data.applystatus.forEach(element => {
          dat.push({ id: element.id, name: element.name });
        });
        this.myOptions = dat;
      }
    );
  }

  onChange($event) {
  }


  getStatusColor (msg) {
    let b: boolean = false;
    if (msg.filters.status || msg.favorite)
      b = true;
    return b;
  }

  getOfferInput($event){
    this.jobId = $event.id;
  }
  getNameStatus(msg) {
    let s:string = "";

    let favorite = msg.favorite;

    let a;
    if (favorite)
      s += "Favoritos,";

    if (msg.filters.status) {
      a = msg.filters.status.indexOf(-1);

      if (msg.filters.status.indexOf(-1)>=0)
        s += "Descartados,";

      a = msg.filters.status.indexOf(0);
      if (msg.filters.status.indexOf(0)>=0)
        s+= "Sin Leer,";

      a = msg.filters.status.indexOf(100);
      if (msg.filters.status.indexOf(100)>=0)
        s += "Leídos,";

      if (msg.filters.status.indexOf(275)>=0)
        s += "Seleccionados,";

      if (msg.filters.status.indexOf(300)>=0)
        s += "Seleccionados,";
    }

    s = s.replace(/,\s*$/, '');
    return (s);
  }

  getOffers() {
    let status = [];
    status.push('1');
    status.push('-1');
    status.push('-2');
    status.push('-3');
    status.push('-6');

    this.jobs = this.jobService.getOffers(undefined, undefined, status, 1, 1000000)
      .do(() => this.jobId = '')
      .map(res => res.jobs);
  }

  beforeTabChange($event:NgbTabChangeEvent) {
      this.req= $event.nextId === 'msg_direct' ? 1 : 0;
      this.searchMessages(this.req === 1 ? this.currentPageDirect: this.currentPageMassive);
  }

  showDetailsMessage(title, content) {
      this.dialog.open(MessageBoxDialog, {data: {title: title, message: content, alert:true, showIcon:false}});
  }

  searchMessages(page) {

    this.loading = true;

    let status = [];

    if (this.rejected) {
      status.push('-1');
    }
    if (this.read) {
      status.push('100');
    }
    if (this.unread) {
      status.push('0');
    }
    if (this.selected) {
      status.push('275');
    }
    if (this.hired) {
      status.push('300');
    }
    if(this.optionsModel){
      this.optionsModel.forEach(element => {
        let number = ""+element
        status.push(number);
      });
    }

    let messages;

    if (this.req) {
      messages = this.messageService.getMessagesDirect(page, this.maxMessagesDirect,
        this.query, this.favorite, status, this.jobId, this.req);
    } else {
      messages = this.messageService.getMessagesMassive(page, this.maxMessagesMassive,
        this.query, this.favorite, status, this.jobId, this.req);
    }

    messages.subscribe(
      data => {
        if (this.req === 1) {
          this.messagesDirect = data.messages;
          this.paginationDirect = data.pagination;
          this.currentPageDirect = page;
        } else {
          this.messagesMassive = data.messages;
          this.paginationMassive = data.pagination;
          this.currentPageMassive = page;
        }

        this.loading = false;
      },
      error => {
        if (error.status == 404) {
          if (this.req === 1) {
            this.messagesDirect = [];
          } else {
            this.messagesMassive = [];
          }
          this.loading = false;
        } else {
          console.log(error);
          this.loading = false;
        }
      }
    );
  }

  openDialog() {
      let dialogRef = this.dialog.open(SendMessageComponent, {data: {
        nameComponent: 'message', useFilter: true, jobs: this.jobs
      }});

      dialogRef.afterClosed().subscribe(result => {
        this.selectedOption = result;
      });
  }

  onPageChange(page) {
    this.searchMessages(page);
  }

  showInformation() {
    this.dialog.open(MessageBoxDialog, {data: {message: 'Podrás ver el estado de los mensajes enviados a los candidatos de forma individual o masiva, recuerda que este modulo solo te podrá informar si el candidato leyó o no el mensaje enviado. Los mensajes solo funcionan de forma unilateral lo cual imposibilita al candidato responder por medio de la aplicación móvil.', information: true, showIcon: true}});
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/message/message.component.ts